export default __webpack_public_path__ + "static/media/cplusplus.8e156219.svg";